import React from "react";
import PropTypes from "prop-types";
import XLSX from "xlsx";
import { saveAs } from "file-saver";

const s2ab = (s) => {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
  return buf;
};

const DownloadsModal = ({ countryData, currentType, forComparative }) => {
  // console.log(props);
  // Code credit: https://redstapler.co/sheetjs-tutorial-create-xlsx/
  const wb = XLSX.utils.book_new();
  wb.Props = {
    Title: "Utilities data",
    Subject: "Utilities data",
    Author: "GWI WaterData",
    CreatedDate: new Date(),
  };

  wb.SheetNames.push("Data");

  const opts = {
    nrw: {
      name: "nrw",
    },
    privatisation: {
      name: "privatisation",
    },
    utilities: {
      name: "utilities",
    },
  };

  const onClick = (type) => (e) => {
    e.preventDefault();
    e.stopPropagation();

    const name = opts[type].name;
    const time = Date.now();
    const fileName = `waterdata-utilities-${name}-data-${time}.xlsx`;
    let ws_data = [];

    if(type === "nrw") {
      const headers = ["Country name", "NRW rate (%)", "Source", "Year"];
      ws_data.push(headers);
      const rows = countryData.map(country => {
        const { country_name, nrw_average, nrw_data_source, country_nrw_percentage_year, country_nrw_percentage_source } = country;
        let nrw_average_for_sheet;
        let nrw_data_source_for_sheet;
        nrw_average === -1 ? nrw_average_for_sheet = "-" : nrw_average_for_sheet = nrw_average;
        if (nrw_data_source === "Country") {
          nrw_data_source_for_sheet = country_nrw_percentage_source;
        } else if(nrw_data_source === "Utilities") {
          nrw_data_source_for_sheet = "GWI utilities database estimate";
        } else {
          nrw_data_source_for_sheet = nrw_data_source;
        }
        ws_data.push([country_name, nrw_average_for_sheet, nrw_data_source_for_sheet, country_nrw_percentage_year]);
      });
      ws_data.push(rows);
    }

    if(type === "privatisation") {
      const headers = ["Country name", "% private", "Number of concessions", "Number of part-privatised utilities", "Number of investor-owned utilities", "Number of utilities in database"];
      ws_data.push(headers);
      const rows = countryData.map(country => {
        const {
          country_name,
          extent_of_privatisation,
          number_of_concessions,
          number_of_part_privatised,
          number_of_investor_owned,
          number_of_utilities } = country;
        ws_data.push([country_name, extent_of_privatisation, number_of_concessions, number_of_part_privatised, number_of_investor_owned, number_of_utilities]);
      });
      ws_data.push(rows);
    }

    if(type === "utilities") {
      const headers = ["Country name", "Total number of utilities", "Accuracy", "Year", "Source", "Source URL", "Notes"];
      ws_data.push(headers);
      const rows = countryData.map(country => {
        const {
          country_name,
          sheet_utilities_total,
          sheet_utilities_accuracy,
          sheet_utilities_year,
          sheet_utilities_source,
          sheet_utilities_url,
          sheet_utilities_notes,
        } = country;
        ws_data.push([country_name, sheet_utilities_total, sheet_utilities_accuracy, sheet_utilities_year, sheet_utilities_source, sheet_utilities_url, sheet_utilities_notes]);
      });
      ws_data.push(rows);
    }

    const ws = XLSX.utils.aoa_to_sheet(ws_data);
    wb.Sheets["Data"] = ws;
    const wbout = XLSX.write(wb, { bookType: "xlsx",  type: "binary" });

    saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName);
  };

  return (
    <div className="downloads-button-wrapper">
    {!forComparative &&
      <div>
        <a href="#" target="_blank" rel="noreferrer noopener">
          <button onClick={onClick("nrw")}>
            Download NRW data
          </button>
        </a>
        <a href="#" target="_blank" rel="noreferrer noopener">
          <button onClick={onClick("privatisation")}>
            Download privatisation data
          </button>
        </a>
        <a href="#" target="_blank" rel="noreferrer noopener">
          <button onClick={onClick("utilities")}>
            Download utilities data
          </button>
        </a>
      </div>
    }
    {forComparative && currentType == "nrw_average" &&
      <div>
        <a href="#" target="_blank" rel="noreferrer noopener">
          <button onClick={onClick("nrw")}>
            Download NRW data
          </button>
        </a>
      </div>
    }
    {forComparative && currentType == "extent_of_privatisation" &&
      <div>
        <a href="#" target="_blank" rel="noreferrer noopener">
          <button onClick={onClick("privatisation")}>
            Download privatisation data
          </button>
        </a>
      </div>
    }
    {forComparative && currentType == "sheet_utilities_total" &&
      <div>
        <a href="#" target="_blank" rel="noreferrer noopener">
          <button onClick={onClick("utilities")}>
            Download utilities data
          </button>
        </a>
      </div>
    }
    </div>
  );
};

DownloadsModal.propTypes = {
  countryData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  currentType: PropTypes.string.isRequired,
  forComparative: PropTypes.bool.isRequired,
};

export default DownloadsModal;
